import { USER_ROLE } from "../constants/user";

export const isNotAccountant = (role: any): boolean => {
  return !role.includes(USER_ROLE.ACCOUNTANT);
};
